import React, { useState, useEffect } from "react";

import { Row, Col } from 'antd';

import LogoButton from "./LogoButton";
import OpenAppButton from "./OpenAppButton";

export default function GameHeader(props) {
    const popUpState = props.popUpState;
    const setPopUpState = props.setPopUpState;

    const [transparent, setTransparent] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            setTransparent((currentScrollY < 45) ? true : false);
        };

        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => window.removeEventListener("scroll", handleScroll);
    }, [transparent]);



    return (
        <div className={transparent ? "web-hidden" : "web-header-outter-box"}>
            <div className="web-header">
                <Row type="flex" justify="space-between" align="middle" gutter={[8, 8]}>
                    <Col>
                        <LogoButton />
                    </Col>
                    <Col>
                        <OpenAppButton
                            popUpState={popUpState}
                            setPopUpState={setPopUpState}
                            game={true} />
                    </Col>
                </Row>
            </div>
        </div>
    );
}